import { jsxs as a, jsx as t } from "react/jsx-runtime";
import u, { useRef as v, useEffect as x } from "react";
import e from "./index.es2342.js";
import T from "classnames";
import { v4 as h } from "uuid";
import { TooltipProvider as _ } from "@radix-ui/react-tooltip";
import { Divider as b } from "./index.es18.js";
import { MenuText as c } from "./index.es490.js";
import { SimpleTooltip as A } from "./index.es120.js";
import { IconButton as N } from "./index.es12.js";
const D = "data-grid-action-toolbar", $ = u.memo(
  ({
    selectedCount: n = 0,
    rowNames: s = "Rows",
    visible: r,
    testId: o = D,
    actionItems: d = [],
    autofocus: l = !0
  }) => {
    const m = v(null), p = T(e.root, { [e.visible]: r });
    return x(() => {
      r && l && setTimeout(() => {
        var i;
        (i = m.current) == null || i.focus();
      }, 1e3);
    }, [l, r]), /* @__PURE__ */ a("div", { "data-testid": o, className: p, ref: m, tabIndex: -1, children: [
      /* @__PURE__ */ a(
        "div",
        {
          className: e.textContainer,
          "data-testid": o + "-text-container",
          "aria-label": `${n} ${s} Selected`,
          children: [
            /* @__PURE__ */ t(c, { variant: "semi-bold", isEllipsis: !0, children: n }),
            /* @__PURE__ */ a(c, { variant: "semi-bold", isEllipsis: !0, children: [
              s,
              " Selected"
            ] })
          ]
        }
      ),
      /* @__PURE__ */ t("div", { className: e.divider, children: /* @__PURE__ */ t(b, { isVertical: !0, margin: "12px 24px", dividerLength: "14px" }) }),
      /* @__PURE__ */ t(
        "div",
        {
          className: e.actionsContainer,
          "data-testid": o + "-actions-container",
          tabIndex: 0,
          children: d.map(({ tooltip: i, ...f }) => /* @__PURE__ */ t(_, { children: /* @__PURE__ */ t(A, { title: i, placement: "top", children: /* @__PURE__ */ t(
            N,
            {
              ...f,
              "aria-label": i ?? "action item",
              variant: "ghost"
            }
          ) }) }, h()))
        }
      )
    ] });
  }
);
export {
  $ as ActionToolbar,
  D as DATA_GRID_ACTION_TOOL_BAR_DEFAULT_TESTID
};
//# sourceMappingURL=index.es538.js.map
